import React, { useEffect, useRef, useState } from "react";

/**
 * Blendet children sanft ein, sobald sie beim Scrollen in den sichtbaren Bereich kommen.
 * Nutzt IntersectionObserver statt eines Scroll-Listeners (performanter, kein Jank).
 * Läuft nur einmal pro Element (kein Zurückspringen beim Hoch-/Runterscrollen).
 */
export function Reveal({ children, className = "", delay = 0, as: Tag = "div" }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // Falls der Browser IntersectionObserver nicht kann: sofort anzeigen statt für immer versteckt zu bleiben.
    if (typeof IntersectionObserver === "undefined") { setVisible(true); return; }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(28px)",
        transition: `opacity 0.8s cubic-bezier(0.16,1,0.3,1) ${delay}s, transform 0.8s cubic-bezier(0.16,1,0.3,1) ${delay}s`,
      }}
    >
      {children}
    </Tag>
  );
}
